import { init, setUserId, Identify, identify, reset, track } from '@amplitude/analytics-browser';
import { useSelector } from 'react-redux';
import { AMPLITUDE_EVENT_ERROR_OCCURRED } from '../models/Constants';

const AMPLITUDE_API_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY;

let isInitialized = false;

export const initAmplitude = () => {
	if (isInitialized) return;

	init(AMPLITUDE_API_KEY, {
		defaultTracking: {
			sessions: true,
			pageViews: {
                trackOn: () => window.location.pathname.startsWith('/dashboard'),
                trackHistoryChanges: 'pathOnly',
            },
			formInteractions: false,
			fileDownloads: false,
		},
	});

	isInitialized = true;
};

export const setAmplitudeUserId = (userId) => {
	if (!userId) return;
	setUserId(userId);
};

export const setAmplitudeUserProperties = (properties) => {
	const identifyEvent = new Identify();
	Object.entries(properties).forEach(([key, value]) => {
		identifyEvent.set(key, value);
	});
	identify(identifyEvent);
};

export const resetAmplitude = () => {
    // reset user identity
	reset();
};

export const trackEvent = (eventName, properties = {}) => {
	track(eventName, {
		...properties,
		timestamp: new Date().toISOString(),
	});
};

const useAmplitudeTracking = () => {
    const currentCapabilities = useSelector((state) => state.auth.current_capabilities);
    const userDetails = useSelector((state) => state.auth.user_details);

    const trackEventWithProperties = (eventName, properties = {}) => {
        trackEvent(eventName, {
            ...properties,
            // user props
            user_id: userDetails?.id || userDetails?.user_id,
            // company props
            company_id: currentCapabilities?.company?.company_id,
            company_name: currentCapabilities?.company?.company_name,
            // role props
            role_id: currentCapabilities?.role,
            role_name: currentCapabilities?.role_name,
            timestamp: Date.now(),
        });
    }

    const trackErrorEvent = (type, message, metadata = {}) => {
        trackEventWithProperties(AMPLITUDE_EVENT_ERROR_OCCURRED, {
            error_type: type,
            error_message: message,
            ...metadata
        });
    }

    return {
        trackErrorEvent,
        trackEventWithProperties,
    };
}

export default useAmplitudeTracking;